export const BANK_ACCOUNT_TYPE = "בנק" as const;
export const BANKS_PATH = "/banks";
export const BANKS_BREADCRUMB = { ledger: "כרטסות", list: "בנקים" } as const;
export const BANKS_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
